module.exports = __webpack_public_path__ + "static/assets/f30c30ea30662db3c3fe27ef024d8800.svg";